import React, { useEffect, useState } from "react";
import searchIcon from "../../img/icon-search.png";
import "../../css/common.css";
import dotsIcon from "../../img/icondots.png";
import { Link, useHistory } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { BACKEND_URL, GeneralStatus } from "../../utils/constant";
import { Pagination } from "../../components/Pagination";
import editIcon from "../../img/icon-edit.png";
import trashCanIcon from "../../img/icon-trash.png";
import detailIcon from "../../img/icon-details.png";
import crossIcon from "../../img/icon-cross.png";
import { useFormatMessage } from "../../hooks/useFormatMessage";
import { useAuth } from "../../context/AuthProvider";
import DeleteConfirmPopup from "../../components/DeleteConfirmPopup";
import moment from "moment";

export default function BankTransaction() {
    const history = useHistory();
    const { setPopup } = useAuth();
    const currentPath = history.location.pathname;
    const [isOptionOpen, setisOptionOpen] = useState(false);
    const { data, setCurrentPage, setQuery, reload } = useFetchData({
        url: BACKEND_URL + "/bankTransaction",
        defaultQuery: "",
    });
    const formatMessage = useFormatMessage();

    const toggleOptions = (id) => {
        const optionEl = document.getElementById(id);
        const activeOptionEl = document.querySelectorAll(".popup-options.open");
        console.log(activeOptionEl);
        if (activeOptionEl.length === 0 || activeOptionEl[0] == optionEl) {
            optionEl.classList.toggle("open");
            setisOptionOpen(optionEl.classList.contains("open"));
        }
    };

    const onSearchChange = (e) => {
        const text = e.target.value;
        setQuery({
            bank_account: text.trim(),
        });
    };

    const onDeleteClick = (e) => {
        e.preventDefault();
        const id = e.target.parentNode.id
            ? e.target.parentNode.id
            : e.target.parentNode.parentNode.id;
        setPopup(
            <DeleteConfirmPopup
                id={id}
                reload={reload}
                entity="bankTransaction"
            />
        );
    };

    useEffect(() => {
        const openedEl = document.querySelector(".popup-options.open");

        const handleDocumentClick = (e) => {
            if (e.target != openedEl && !openedEl.contains(e.target)) {
            }
            openedEl.classList.remove("open");
            setisOptionOpen(false);
        };
        if (openedEl) {
            setTimeout(() => {
                document.addEventListener("click", handleDocumentClick);
            }, 100);
        }
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [isOptionOpen]);

    return (
        <div className="page-layout">
            <div className="page-header">
                <h1>{formatMessage("common.bankTransactionList")}</h1>
                <div className="search-bar">
                    <img src={searchIcon} />
                    <input
                        className="x-input"
                        type="search"
                        onChange={onSearchChange}
                    />
                </div>
                <Link
                    to="/dashboard/bankTransaction/create"
                    className="create-button"
                >
                    {formatMessage("common.createNew")}
                </Link>
            </div>

            <div className="table-container">
                <table className="x-table">
                    <thead>
                        <tr>
                            <th style={{ maxWidth: "130px" }}>
                                {formatMessage("common.bankName")}
                            </th>
                            <th style={{ maxWidth: "130px" }}>
                                {formatMessage("common.accountNumber")}
                            </th>
                            <th style={{ maxWidth: "130px" }}>
                                {formatMessage("common.transactionType")}
                            </th>
                            <th style={{ maxWidth: "130px" }}>
                                {" "}
                                {formatMessage("common.mmkAmount")}
                            </th>
                            <th style={{ maxWidth: "130px" }}>
                                {" "}
                                {formatMessage("common.yunAmount")}
                            </th>
                            <th style={{ maxWidth: "130px" }}>
                                {" "}
                                {formatMessage("common.transactionDate")}
                            </th>
                            <th className="button-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.results.map((item, i) => {
                            const index = (data.page - 1) * data.limit + i + 1;
                            return (
                                <tr key={i} className="hover-effect">
                                    <td style={{ maxWidth: "130px" }}>
                                        {item.bankAccount.bank.bank_name}
                                    </td>
                                    <td style={{ maxWidth: "130px" }}>
                                        {item.bankAccount.bank_account}
                                    </td>
                                    <td style={{ maxWidth: "130px" }}>
                                        {item.trx_type}
                                    </td>
                                    <td style={{ maxWidth: "130px" }}>
                                        {item.mmk_trx_amount}
                                    </td>
                                    <td style={{ maxWidth: "130px" }}>
                                        {item.yun_trx_amount.toFixed(2)}
                                    </td>
                                    <td style={{ maxWidth: "130px" }}>
                                        {moment(item.bank_trx_date).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </td>
                                    <td className="button-col">
                                        <span
                                            className={
                                                item.status === "ACTIVE"
                                                    ? "flex mr-2 items-center justify-center flex-shrink-0 w-16 h-7 rounded-2xl bg-green-100 text-green-800"
                                                    : "flex mr-2 items-center justify-center flex-shrink-0 w-16 h-7 rounded-2xl bg-gray-100"
                                            }
                                        >
                                            {GeneralStatus[item.status]}
                                        </span>
                                        <div className="flex items-center">
                                            <img
                                                src={detailIcon}
                                                className="col-button"
                                                onClick={() =>
                                                    setPopup(
                                                        <DetailPopup
                                                            data={item}
                                                        />
                                                    )
                                                }
                                            />
                                            <img
                                                className="col-button"
                                                src={dotsIcon}
                                                onClick={
                                                    item.status == "ACTIVE"
                                                        ? () =>
                                                              toggleOptions(
                                                                  item.bank_trx_id
                                                              )
                                                        : null
                                                }
                                            />
                                        </div>
                                        <div
                                            className="popup-options"
                                            id={item.bank_trx_id}
                                        >
                                            <a href="" onClick={onDeleteClick}>
                                                <img src={trashCanIcon} />
                                                {formatMessage("common.remove")}
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="pagination-container">
                <Pagination data={data} setCurrentPage={setCurrentPage} />
            </div>
        </div>
    );
}

const DetailPopup = ({ data }) => {
    const formatMessage = useFormatMessage();
    const { setPopup } = useAuth();

    return (
        <div className="popup relative">
            <h4 className="mb-10">
                {formatMessage("common.bankTransaction")}
                {formatMessage("common.information")}
            </h4>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.bankName")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {data.bankAccount.bank.bank_name}
                </span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.accountNumber")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {data.bankAccount.bank_account}
                </span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.transactionType")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">{data.trx_type}</span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.mmkAmount")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">{data.mmk_trx_amount}</span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.yunAmount")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">{data.yun_trx_amount}</span>
            </div>
            <div className="mb-8">
                <span className="inline-block w-60">
                    {formatMessage("common.transactionDate")}
                </span>
                <span className="mr-20">:</span>
                <span className="inline-block w-52">
                    {moment(data.bank_trx_date).format("DD/MM/YYYY")}
                </span>
            </div>

            <img
                className="absolute top-7 right-8 cursor-pointer w-3 h-auto"
                src={crossIcon}
                onClick={() => setPopup(null)}
            />
        </div>
    );
};
